export default {
  // Page titles
  'pages.ops.version.title': 'Version Management',
  'pages.ops.version.subtitle': 'App APK release and update management',

  // App types
  'pages.ops.version.appType.PAD': 'Tablet Ordering App',
  'pages.ops.version.appType.APOS': 'POS Ordering App',
  'pages.ops.version.appType.BPOS': 'B-Account App',

  // Table columns
  'pages.ops.version.column.appType': 'App',
  'pages.ops.version.column.platform': 'Platform',
  'pages.ops.version.column.versionName': 'Version',
  'pages.ops.version.column.versionCode': 'versionCode',
  'pages.ops.version.column.updateLog': 'Release Notes',
  'pages.ops.version.column.status': 'Status',
  'pages.ops.version.column.publishTime': 'Published At',
  'pages.ops.version.column.createTime': 'Created At',
  'pages.ops.version.column.updateTime': 'Updated At',
  'pages.ops.version.column.action': 'Actions',
  'pages.ops.version.column.tenant': 'Target Tenant',
  'pages.ops.version.column.store': 'Target Store',

  // Target scope
  'pages.ops.version.scope.global': 'Global',
  'pages.ops.version.scope.allStores': 'All Stores',

  // Status
  'pages.ops.version.status.published': 'Published',
  'pages.ops.version.status.unpublished': 'Unpublished',

  // Actions
  'pages.ops.version.action.publish': 'Publish',
  'pages.ops.version.action.offline': 'Unpublish',
  'pages.ops.version.action.delete': 'Delete',
  'pages.ops.version.action.edit': 'Edit',
  'pages.ops.version.action.download': 'Download',
  'pages.ops.version.delete.confirm': 'Delete this version?',
  'pages.ops.version.msg.downloadNotPublished':
    'Only published versions can be downloaded',

  // Search
  'pages.ops.version.search.appType.all': 'All',
  'pages.ops.version.search.tenant': 'Tenant',
  'pages.ops.version.search.tenant.placeholder': 'Select a tenant',
  'pages.ops.version.search.store': 'Store',
  'pages.ops.version.search.store.placeholder': 'Select a tenant first',

  // Multi-select
  'pages.ops.version.select.all': 'Select All',
  'pages.ops.version.select.invert': 'Invert',

  // Target mode
  'pages.ops.version.mode.all': 'All',
  'pages.ops.version.mode.include': 'Specified',
  'pages.ops.version.mode.exclude': 'Excluded',

  // Buttons / add-edit page
  'pages.ops.version.button.add': 'Add Version',
  'pages.ops.version.addTitle': 'New App Version',
  'pages.ops.version.editTitle': 'Edit App Version',
  'pages.ops.version.cancel': 'Cancel',
  'pages.ops.version.save': 'Save',

  // Card sections
  'pages.ops.version.card.basic': 'Basic Info',
  'pages.ops.version.card.target': 'Targeted Release',
  'pages.ops.version.card.apk': 'APK File',

  // Form
  'pages.ops.version.form.appType': 'App',
  'pages.ops.version.form.platform': 'Platform',
  'pages.ops.version.form.updateLog': 'Release Notes',
  'pages.ops.version.form.updateLog.placeholder': "What's new in this release",
  'pages.ops.version.form.tenantMode': 'Tenant Scope',
  'pages.ops.version.form.tenant': 'Target Tenant',
  'pages.ops.version.form.tenant.placeholder': 'Empty = Global',
  'pages.ops.version.form.storeMode': 'Store Scope',
  'pages.ops.version.form.store': 'Target Store',
  'pages.ops.version.form.store.placeholder':
    'Empty = All stores of selected tenants',

  // Upload
  'pages.ops.version.upload.button': 'Select APK to Upload',
  'pages.ops.version.upload.uploading': 'Uploading APK, please wait…',
  'pages.ops.version.upload.success': '✓ Upload successful',
  'pages.ops.version.upload.file': 'File',
  'pages.ops.version.upload.size': 'Size',
  'pages.ops.version.upload.versionName': 'Version',
  'pages.ops.version.upload.unrecognized': '(unrecognized)',

  // Messages
  'pages.ops.version.msg.uploadFailed':
    'APK upload failed, no download URL returned',
  'pages.ops.version.msg.parseWarning':
    'APK uploaded, but versionCode/versionName could not be parsed. Please make sure it is a valid APK',
  'pages.ops.version.msg.uploadSuccess': 'APK uploaded',
  'pages.ops.version.msg.needApk': 'Please upload an APK first',
  'pages.ops.version.msg.parseFailed':
    'Failed to parse APK version info. Please re-upload a valid APK',
  'pages.ops.version.msg.createSuccess':
    'Version created. Click "Publish" in the list to take effect',
  'pages.ops.version.msg.updateSuccess': 'Version updated',
  'pages.ops.version.msg.tenantRequired': 'Please select tenants',
  'pages.ops.version.msg.storeRequired': 'Please select stores',
  'pages.ops.version.msg.published': 'Published',
  'pages.ops.version.msg.offlined': 'Unpublished',
  'pages.ops.version.msg.deleted': 'Deleted',

  // Published-version lock hints (frontend-only: draft/offline are editable & deletable; published must be taken offline first)
  'pages.ops.version.msg.publishedNoEdit':
    'This version is published and locked. Unpublish it before editing.',
  'pages.ops.version.msg.publishedNoDelete':
    'Published versions cannot be deleted. Unpublish it first.',
};
